<template>
  <div class="tx">
    <div class="center" v-if="commssionList!=null">
      <div class="ctdiv" v-for="(item,index) in commssionList" :key="index">
        <div class="info">
          <div style="font-size:18px;font-weight:bold;">{{ item.typeName }}</div>
          <span class="span" v-if="item.status==0">提现时间：{{ item.applytime }}</span>
          <span class="span" v-if="item.status==2">审核时间：{{ item.checktime }}</span>
          <span class="span" v-if="item.status==3">到账时间：{{ item.paytime }}</span>
        </div>
        <div class="content">
          <div class="price">
            <span>提现金额：</span>
            <div style="font-size:18px;font-family:MicrosoftYaHeiLight;font-weight:400;">￥{{ item.money }}</div>
          </div>
          <span class="span" v-if="item.cashType == 1">提现到微信零钱</span>
          <span class="span" v-if="item.cashType == 2">提现银行：{{ item.bankName }}</span>
        </div>
      </div>
    </div>
    <div class="centertext" v-if="commssionList == null || commssionList.length == 0">
      <h3 style="margin-top:30%;">暂无提现记录</h3>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MerTokerCashDetail',
  data () {
    return {
      commssionList: [],
      title: '提现明细'
    }
  },
  created () {
    this.$common.changetitle(this.title)
    this.queryData = this.$route.query
    this.commssionListinfo()
  },
  methods: {
    commssionListinfo: function () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/commission/list',
        data: {
          merId: this.queryData.merId,
          uid: this.queryData.uid,
          moneyType: this.queryData.moneyType
        },
        login: false
      }).then(res => {
        this.commssionList = res.data
      })
    },
  }
}
</script>
<style scoped>
body {
  background-color: white;
}

.tx {
  margin-top: 50px;
  background: white;
}

.center {
  flex-direction: column;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.centertext {
  width: 100%;
  height: 100%;
  text-align: center;
}

.ctdiv {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  width: 95vw;
  margin-top: 5%;
  margin-bottom: 5%;
  padding-top: 1px;
  background-color: rgba(239, 239, 239, 1);
  border-radius: 10px;
}

.ctdiv .info {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 10px;
}

.ctdiv .content {
  display: flex;
  flex-direction: column;
  margin: 10px;
}

.ctdiv .content .price {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ctdiv .span {
  margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerCashDetail.vue